import React, { PureComponent } from 'react'
import T from 'prop-types'
import cx from 'classnames'
import IT from 'react-immutable-proptypes'
import {
  List
} from 'immutable'
import {
  FORM_STYLES
} from '../types'
import {
  SCHEMA_ITEM_SHAPE,
  FIELD_OPTIONS_SHAPE,
  CUSTOM_INPUTS_SHAPE,
  SCHEMA_SHAPE
} from '../shapes'
import {
  Button,
  TextOverflow
} from 'react-base'
import Inputs from './Inputs'
import {
  pluralize
} from 'pw-formatters'


export default class NestedCollection extends PureComponent {
  static displayName = 'Schemer.NestedCollection'

  static propTypes = {
    className: T.string,
    readOnly: T.bool.isRequired,
    style: T.oneOf(Object.keys(FORM_STYLES)),
    required: T.bool,

    schema: SCHEMA_SHAPE.isRequired,
    fieldName: T.string.isRequired,
    field: SCHEMA_ITEM_SHAPE,

    currentValue: IT.listOf(IT.map),
    validate: T.func, // If passed, will be passed all group values after each input change. If a string is returned the group is considered invalid

    onChange: T.func.isRequired,
    onValidationChange: T.func.isRequired,
    customInputs: CUSTOM_INPUTS_SHAPE,
    fieldOptions: FIELD_OPTIONS_SHAPE
  }

  static defaultProps = {
    currentValue: List()
  }

  state = {
    collectionInvalidMsg: null,
    childHasFocus: false
  }

  componentWillMount() {
    this._validateCollection(this.props)
  }

  componentWillReceiveProps(nextProps) {
    this._validateCollection(nextProps)
  }

  _validateCollection = props => {
    const {
      schema,
      currentValue,
      field,
      fieldName,
      onValidationChange,
      required
    } = props
    if (!schema || !field) {
      return
    }
    const {
      editable,
      display,
      validate
    } = field.toJS()
    const {
      maxAllowed
    } = editable

    let newInvalidMsg = []
    if (required && currentValue && currentValue.size === 0) {
      newInvalidMsg.push(`At least one entry is required.`)
    }
    if (maxAllowed && currentValue && currentValue.size > maxAllowed) {
      newInvalidMsg.push(`Maximum of ${maxAllowed} ${pluralize(maxAllowed, 'entry', 'entries')} allowed.`)
    }

    // Call passed NestedCollection validator if supplied
    if (validate) {
      const collectionInvalidMsg = validate(currentValue, schema)
      if (collectionInvalidMsg) {
        newInvalidMsg.push(collectionInvalidMsg)
      }
    }

    newInvalidMsg = newInvalidMsg.join("\r\n")

    onValidationChange(newInvalidMsg, display, fieldName)
    this.setState({
      collectionInvalidMsg: newInvalidMsg
    })
  }

  handleInputChange = (newValue, fieldName, rowIndex) => {
    const {
      currentValue
    } = this.props
    const newCurrentValue = currentValue.set(rowIndex, currentValue.get(rowIndex).set(fieldName, newValue))
    this.emitChange(newCurrentValue)
  }

  emitChange = newValue => {
    const {
      onChange,
      fieldName
    } = this.props
    onChange(newValue, fieldName)
  }

  handleValidationChange = (validationMsg, inputFieldDisplay, inputFieldName, rowIndex) => {
    const {
      fieldName,
      field,
      onValidationChange
    } = this.props
    const display = field.get('display')

    onValidationChange(validationMsg, `${display} (#${rowIndex + 1}): ${inputFieldDisplay}`, fieldName)
  }

  handleAddItemClick = () => {
    const {
      currentValue = List(),
      schema
    } = this.props
    const newBlankItem = schema.map(() => null)
    this.emitChange(currentValue.push(newBlankItem))
  }

  handleRemoveRowClick = (rowIndex) => {
    const {
      currentValue
    } = this.props
    this.emitChange(currentValue.delete(rowIndex))
  }

  handleChildFocus = () => {
    // Slight delay so this "Wins" with in-child focus changes
    setTimeout(() => {
      this.setState({
        childHasFocus: true
      })
    }, 250)
  }

  handleChildBlur = () => {
    this.setState({
      childHasFocus: false
    })
  }

  render() {
    const  {
      style,
      readOnly,
      field,
      schema,
      currentValue,
      required,
      customInputs,
      fieldOptions
    } = this.props
    const {
      collectionInvalidMsg,
      childHasFocus
    } = this.state
    const {
      display,
      editable
    } = field.toJS()
    const {
      layout,
      maxAllowed
    } = editable

    return (
      <div
        className={cx(
          `schemer_fieldset`,
          `schemer_nested_collection layout_${layout.toLowerCase()}`,
          {
            child_has_focus: childHasFocus,
            no_entries: !currentValue || (currentValue && currentValue.size === 0)
          }
        )}
      >
        <header>
          <div className="heading">
            <TextOverflow>
              {display}
            </TextOverflow>
            {required &&
              <span
                className={`required_field`}
                data-tooltip={`Required section`}
              />
            }
          </div>
        </header>
        {collectionInvalidMsg &&
          <div className="schemer_fieldset_validation_errors">
            {collectionInvalidMsg}
          </div>
        }
        <section className="schemer_fieldset_fields schemer_nested_collection_rows">
          {currentValue && currentValue.entrySeq().map(([i, val]) => {
            return (
              <div
                className="schemer_nested_row"
                key={`row_${i}`}
              >
                <Inputs
                  schema={schema}
                  onChangeArgs={[i]}
                  onChange={this.handleInputChange}
                  onValidationChange={this.handleValidationChange}
                  readOnly={readOnly}
                  style={style}
                  currentValues={val}
                  onFocus={this.handleChildFocus}
                  onBlur={this.handleChildBlur}
                  customInputs={customInputs}
                  fieldOptions={fieldOptions}
                />
                <Button
                  className={`remove_row_btn schemer_icon_btn btn-icon icon-trash`}
                  args={[i]}
                  el={'button'}
                  type="button"
                  stopPropagation
                  onClick={this.handleRemoveRowClick}
                  data-tooltip={`Remove entry`}
                />
              </div>
            )
          })}
          {!readOnly && (!currentValue || (currentValue && currentValue.size < maxAllowed)) &&
            <div>
              <button
                className={`add_row_btn btn btn-xs btn-default`}
                onClick={this.handleAddItemClick}
                type="button"
              ><span className="icon icon-plus" /> Add Entry</button>
            </div>
          }
        </section>
      </div>
    )
  }
}